
import CheckboxField from '@/components/processing_steps/commons/fields/CheckboxField.vue'
import SingleSelectField from '@/components/processing_steps/commons/fields/SingleSelectField.vue'
import FormContainer from '@/components/processing_steps/commons/forms/FormContainer.vue'
import OrgaValidationMixin from '@/mixins/OrgaValidationMixin'
import { IPSFundingApplicationAdminCompletitionForm } from '@/types/fundingApplication'
import { IPSSelectOption } from '@/types/processingSteps'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Reversions from '../../commons/Reversions.vue'

@Component({
  components: {
    FormContainer,
    CheckboxField,
    SingleSelectField,
    Reversions
  }
})
export default class AdminCompletition extends Mixins(OrgaValidationMixin) {
  // todo: remove organization and set the other select options as for available_content_review_status
  @Prop() completitionForm: IPSFundingApplicationAdminCompletitionForm
  @Prop() fundingApplicationSlug!: string

  get available_content_review_status(): IPSSelectOption[] {
    return [
      { value: "1", text: this.$gettext('please choose…') },
      { value: "2", text: this.$gettext('content accepted') },
      { value: "3", text: this.$gettext('content rejected') }
    ]
  }

  get available_confirmation_of_receipt_status (): IPSSelectOption[] {
    return [
      { value: "1", text: this.$gettext('Pending') },
      { value: "2", text: this.$gettext('Awaiting response') },
      { value: "3", text: this.$gettext('Not signed') },
      { value: "4", text: this.$gettext('Signed') },
      { value: "5", text: this.$gettext('Signature confirmed') },
      { value: "6", text: this.$gettext('Signature rejected') },
      { value: "7", text: this.$gettext('Not required') }
    ]
  }

  get canChangeConfirmationOfReceiptStatus(): boolean {
    return this.completitionForm.confirmation_of_receipt_status === "3" ||
           this.completitionForm.confirmation_of_receipt_status === "4"
  }

  get available_donation_agreement_status (): IPSSelectOption[] {
    return this.available_confirmation_of_receipt_status
  }

  get canChangeDonationAgreementStatus(): boolean {
    return this.completitionForm.donation_agreement_status === "3" ||
           this.completitionForm.donation_agreement_status === "4"
  }

  get available_status (): IPSSelectOption[] {
    return [
      { value: "1", text: this.$gettext('In progress') },
      { value: "2", text: this.$gettext('Complete') },
      { value: "3", text: this.$gettext('Archived') },
      { value: "4", text: this.$gettext('Paused') }
    ]
  }

  get available_review_status (): IPSSelectOption[] {
    // todo discuss the wording and change backend accordingly
    return [
      { value: "1", text: this.$gettext('Please choose…') },
      { value: "2", text: this.$gettext('Successfully finished') }, // Public
      { value: "3", text: this.$gettext('Rejected') }
      // { value: "4", text: this.$gettext('Accepted') }
    ]
  }
}
